/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-accordion-arrow-left': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<path pid="0" d="M7 10.5h12M12.166 16.5l-6-6 6-6" _stroke="#8A8A9E" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
